module.exports = __webpack_public_path__ + "img/discord.6ce1124a.png";